import { API } from "api/api";

export const get = (endPoint: string) => {
  return new Promise((resolve, reject) => {
    API.get(endPoint)
      .then((response) => resolve(response))
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
};
